"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttemptExhaustedEventData = void 0;
class MessageAttemptExhaustedEventData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageAttemptExhaustedEventData.attributeTypeMap;
    }
}
exports.MessageAttemptExhaustedEventData = MessageAttemptExhaustedEventData;
MessageAttemptExhaustedEventData.discriminator = undefined;
MessageAttemptExhaustedEventData.attributeTypeMap = [
    {
        "name": "appId",
        "baseName": "appId",
        "type": "string",
        "format": ""
    },
    {
        "name": "appUid",
        "baseName": "appUid",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointId",
        "baseName": "endpointId",
        "type": "string",
        "format": ""
    },
    {
        "name": "lastAttempt",
        "baseName": "lastAttempt",
        "type": "MessageAttemptFailedData",
        "format": ""
    },
    {
        "name": "msgEventId",
        "baseName": "msgEventId",
        "type": "string",
        "format": ""
    },
    {
        "name": "msgId",
        "baseName": "msgId",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=MessageAttemptExhaustedEventData.js.map